import styled from 'styled-components';

const InlineListItemWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export default InlineListItemWrapper;
